"use strict";

exports.__esModule = true;
exports["default"] = CircleClose;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleClose(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.951 4.324c-5.689-5.689-14.944-5.689-20.633-.001-5.685 5.686-5.681 14.937.006 20.627 5.688 5.685 14.935 5.685 20.623 0 5.685-5.689 5.689-14.939.004-20.626zm-3.601 17.02a2.172 2.172 0 0 1-1.55.643 2.184 2.184 0 0 1-1.549-.639l-3.618-3.618-3.619 3.618c-.411.411-.96.639-1.547.639a2.173 2.173 0 0 1-1.55-.641 2.197 2.197 0 0 1-.002-3.101l3.616-3.619-3.609-3.608a2.19 2.19 0 0 1 3.096-3.098l3.612 3.609 3.618-3.616a2.178 2.178 0 0 1 1.549-.641c.586 0 1.138.228 1.552.643a2.196 2.196 0 0 1-.002 3.099l-3.614 3.618 3.614 3.615c.415.413.643.962.643 1.55a2.15 2.15 0 0 1-.639 1.546z"
  }));
}